import {Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, inject} from '@angular/core';
import {ClsConfig} from '../../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IgxDialogComponent } from '@infragistics/igniteui-angular/dialog';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxFocusDirective, IgxLayoutModule } from '@infragistics/igniteui-angular/directives';
import {IGX_SELECT_DIRECTIVES, IgxSelectComponent, IgxSelectItemComponent} from '@infragistics/igniteui-angular/select';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {AppInfoService} from '../../../../core/services/app-info.service';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {GenericoService} from '../../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {EnumMasOpciones, EnumPosicionBtn} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../../util/cls-util';
import {FiltroGeneralComponent} from '../../controles/filtro-general/filtro-general.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {MasOpcionesGridComponent} from '../../controles/mas-opciones-grid/mas-opciones-grid.component';
import {INeodataBtnsFooter} from "../../../../core/models/interfaces/generico-interface";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import { CrearComponenteDinamicoService } from '../../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-diferencias',
  templateUrl: './diferencias.component.html',
  styleUrls: ['./diferencias.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    IgxLayoutModule,
    TranslateModule,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
    IgxIconComponent,
    IGX_SELECT_DIRECTIVES,
    FormsModule,
    IgxFocusDirective,
    IgxSelectComponent,
    IgxSelectItemComponent
  ]
})
export class DiferenciasComponent extends ClsConfig implements OnInit {
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('vtnDiferenciasDialog', {static: true})
  public vtnDiferenciasDialog: IgxDialogComponent;

  @ViewChild('gridDiferencias', {static: true})
  public gridDiferencias: IgxGridComponent;

  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  @Input()
  public dataDiferencias: ClsColDiferencia[];
  // Respuesta
  @Output()
  public dataRespuesta: EventEmitter<ClsColDiferencia[]> = new EventEmitter<ClsColDiferencia[]>();

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public acciones: string[] = [];
  public vtnGenerico: VtnGenericaComponent;
  // OBJ
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.acciones.push(this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.MANTENER'));
    this.acciones.push(this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.SUSTITUIR'));
    // EVENTO DE BOTONES VENTANA
    this.vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
      switch (btn.id) {
        case 'SUSTITUIRTODO':
          this.sustituirTodo();
          break;
        case 'MANTERNOTODO':
          this.mantenerTodo();
          break;
        case 'ACEPTAR':
          this.aceptar();
          break;
        default: // cancelar
          this.close(null);
      }
    });
  }

  public open() {
    this.vtnGenerico.btnsAccion = [
      {
        id: 'SUSTITUIRTODO',
        texto: 'BOTONES.SUSTITUIR_TODO',
        titulo: 'BOTONES.SUSTITUIR_TODO',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'MANTERNOTODO',
        texto: 'BOTONES.MANTERNO_TODO',
        titulo: 'BOTONES.MANTERNO_TODO',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'ACEPTAR',
        texto: 'BOTONES.ACEPTAR',
        titulo: 'BOTONES.ACEPTAR',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'CANCELAR',
        texto: 'BOTONES.CANCELAR',
        titulo: 'BOTONES.CANCELAR',
        icono: '',
        tipoBoton: 'flat',
        posicion: EnumPosicionBtn.DERECHO
      }
    ];
    this.vtnGenerico.open(400, 950, 'TITULOS.DIFERENCIAS', 'report');
  }

  public close(data: ClsColDiferencia[]) {
    this.dataRespuesta.emit(data);
    this.vtnGenerico.close();
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridDiferencias.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridDiferencias.filteringLogic = FilteringLogic.Or;
    this.gridDiferencias.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          this.clicked = !this.clicked;
          if (this.clicked) {
            this.themesClass = 'ajustarTexto';
          } else {
            this.themesClass = 'noAjustarTexto';
          }
          break;
        case EnumMasOpciones.ExportarExcel:
          await ClsUtil.exportarDatos(this.gridDiferencias, this.mObjGenerico.getTranslationsSubject('TITULOS.DIFERENCIAS'), this.excelExportService);
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridDiferencias,
            this.mObjGenerico.getTranslationsSubject('TITULOS.DIFERENCIAS'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public sustituirTodo() {
    this.cambiarValorGlobal('MENSAJES.GRALS.SUSTITUIR');
  }

  public mantenerTodo() {
    this.cambiarValorGlobal('MENSAJES.GRALS.MANTENER');
  }

  public aceptar() {
    this.close(this.gridDiferencias.data);
  }

  private cambiarValorGlobal(accion: string) {
    this.gridDiferencias.data.forEach(value => {
      value.Accion = this.mObjGenerico.getTranslationsSubject(accion);
    });
    this.close(this.gridDiferencias.data);
  }
}

export class ClsColDiferencia {
  Codigo: string;
  Campo: string;
  ValorActual: string;
  ValorNuevo: string;
  Accion: string;
}
